
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import CityCard from '../CityCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    CityCard
  }
})
export default class CityListGird extends Vue {
  @Prop({ default: 0 }) marginTop!: number

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  handleToCityPage(cityId: number) {
    if (!cityId) return

    this.$router.push({
      path: `/topic/city/${cityId}`
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
